import {
  ActionIcon,
  Anchor,
  Avatar,
  Badge,
  Box,
  Card,
  Code,
  Flex,
  Grid,
  Text,
  Title,
} from "@mantine/core";
import { IconCheck, IconTrash } from "@tabler/icons";
import { TeaAddonProblem } from "entities/tea_addon_problem";
import { Link } from "react-router-dom";

export type TeaAddonProblemCardProps = {
  problem: TeaAddonProblem;
  deleteProblem: (problem: TeaAddonProblem) => void;
};

export function TeaAddonProblemCard({
  problem,
  deleteProblem,
}: TeaAddonProblemCardProps) {
  return (
    <Card key={problem.id}>
      <Grid>
        <Grid.Col span={4}>
          <Flex direction="column" gap="sm">
            <Badge color="red">{problem.key}</Badge>
            <Badge color="orange">{problem.state}</Badge>
            <Anchor
              component={Link}
              to={`/users/show/${problem.user.id}`}
              target="_blank"
            >
              <Flex align="center">
                <Avatar src={problem.user.image} size="xs" />
                <Text size="xs">{problem.user.email}</Text>
              </Flex>
            </Anchor>
          </Flex>
        </Grid.Col>
        <Grid.Col span={6}>
          <Title order={5} color="gray.7">
            {problem.title}
          </Title>
        </Grid.Col>
        <Grid.Col span={2}>
          <Flex align="center" h="100%">
            {problem.state === "fixed" && (
              <Text color="green" weight="bold" mr="md" italic>
                Fixed!
              </Text>
            )}
            <ActionIcon
              color="gray"
              title="Delete"
              onClick={() => deleteProblem(problem)}
            >
              <IconTrash />
            </ActionIcon>
          </Flex>
        </Grid.Col>
      </Grid>
      <Flex content="center" p="sm">
        <Text size="sm" italic>
          {problem.notes}
        </Text>
      </Flex>
    </Card>
  );
}
